import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getSurveyUniversalQnsAction = createAsyncThunk(
    'get-survey-universal-qns',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/get-survey-universal-qns-ans`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSurveyUniversalQnsSlice = createSlice({
    name: 'get-survey-universal-qns',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSurveyUniversalQnsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSurveyUniversalQnsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getSurveyUniversalQnsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSurveyUniversalQnsReducer = getSurveyUniversalQnsSlice.reducer    